import { createBrowserHistory } from 'history'
import { logger } from './logger'

/**
 * Create and configure custom browser history with recent locations tracking
 */
export const createCustomHistory = () => {
    const customHistory = createBrowserHistory()

    // Save the current location as one of the recent locations.
    customHistory.recentLocations = []
    if (sessionStorage.lastURL) {
        customHistory.recentLocations.push(JSON.parse(sessionStorage.lastURL))
    }
    customHistory.recentLocations.push(customHistory.location)
    sessionStorage.lastURL = JSON.stringify(customHistory.location)

    /**
     * Get the last 3 URLs from the history.
     * @return {T[]} The last 3 locations.
     */
    customHistory.getRecentLocations = function () {
        return customHistory.recentLocations.slice(0)
    }

    customHistory.getPreviousLocation = function () {
        const locations = this.getRecentLocations()
        if (locations.length > 1) {
            return locations[locations.length - 2]
        }
        return undefined
    }

    // Cache the last 3 URLs for pages to determine what should be selected based on last page.
    customHistory.listen(function (location) {
        sessionStorage.lastURL = JSON.stringify(location)
        customHistory.recentLocations.push(location)
        window.Intercom('update')
        logger.setRoute(location.pathname)
        if (customHistory.recentLocations.length > 3) {
            customHistory.recentLocations.shift()
        }
    })

    return customHistory
}
